import { useCallback } from 'react';
import { useDispatch } from 'react-redux';

import {
  CreateReactionRequest,
  DeleteReactionRequest,
  SwitchReactionRequest,
  ViewReactionsRequest
} from './reaction.types';

import {
  requestCreateReaction,
  requestDeleteReaction,
  requestSwitchReaction,
  requestViewReactions
} from './reaction.actions';

export const useReactionApi = () => {
  const dispatch = useDispatch();

  const createReaction = useCallback(
    (requestData: CreateReactionRequest, onSuccess?: () => void, onError?: () => void) => {
      dispatch(requestCreateReaction({ requestData, onSuccess, onError }));
    },
    [dispatch]
  );

  const viewReactions = useCallback(
    (requestData: ViewReactionsRequest, onSuccess?: () => void) => {
      dispatch(requestViewReactions({ requestData, onSuccess }));
    },
    [dispatch]
  );

  const deleteReaction = useCallback(
    (requestData: DeleteReactionRequest, onSuccess?: () => void, onError?: () => void) => {
      dispatch(requestDeleteReaction({ requestData, onSuccess, onError }));
    },
    [dispatch]
  );

  const switchReaction = useCallback(
    (requestData: SwitchReactionRequest) => {
      dispatch(requestSwitchReaction({ requestData }));
    },
    [dispatch]
  );

  return { createReaction, viewReactions, deleteReaction, switchReaction };
};
